import React, { useContext, useEffect } from "react";
import { Button, Layout } from "antd";
import { SessionContext } from "../providers/SessionProvider";
import { AppRoutes } from "../AppRoutes";
import { useNavigate } from "react-router-dom";
import { ResponsiveCard } from "../wizard/components/ResponsiveCard";
import { theme } from "antd";

const { useToken } = theme;
const { Content } = Layout;

interface LoginPageProps {}

export const LoginPage: React.FC<LoginPageProps> = () => {
  const session = useContext(SessionContext);
  const { token } = useToken();
  const navigate = useNavigate();

  useEffect(() => {
    if (session.loading) return;
    if (session.user) {
      navigate(AppRoutes.Dashboard);
    }
  }, [session.user, session.loading, navigate]);

  const handleSignIn = () => {
    const returnTo = encodeURIComponent(window.location.origin);
    window.location.href = `${process.env.REACT_APP_API_NEW_URL}/v4/auth/okta/login?return_to=${returnTo}`;
  };

  return (
    <Layout>
      <Content
        style={{
          width: "100vw",
          height: "100vh",
          background: token.Layout?.headerBg,
        }}
      >
        <ResponsiveCard
          style={{
            display: "block",
            marginLeft: "auto",
            marginRight: "auto",
            marginTop: "10%",
            width: "40%",
            boxShadow: token.boxShadow,
          }}
          title="Login"
          contentPadding="2rem"
        >
          <Button type="primary" onClick={handleSignIn} block>
            Sign in with Okta
          </Button>
        </ResponsiveCard>
      </Content>
    </Layout>
  );
};
